import React, {Component} from 'react'
import {graphql} from 'react-apollo'
import gql from 'graphql-tag'
import {FORM_ERROR} from 'final-form'

const mutation = gql`
  mutation($id: ID!, $validation: String!, $inHomePage: Boolean) {
    modifyValidation(
      id: $id
      validation: $validation
      inHomePage: $inHomePage
    ) {
      error
    }
  }
`

class FicheProducerDisable extends Component {
  disable = (id) => {
    this.props.disableProducer({
      variables: {
        id,
        validation: 'refuse',
        inHomePage: false
      }
    })
  }

  componentDidMount() {
    const {match: { params }} = this.props;
    if (params.id) {
      this.disable(params.id)
    }
  }

  render() {
    return (
      <div>OK</div>
    )
  }
}

export default graphql(mutation, {
  name: 'disableProducer',
})(FicheProducerDisable)
